import { render, staticRenderFns } from "./slide-in-navigation.vue?vue&type=template&id=3dfcaa52&"
import script from "./slide-in-navigation.vue?vue&type=script&lang=js&"
export * from "./slide-in-navigation.vue?vue&type=script&lang=js&"
import style0 from "./slide-in-navigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports